"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=function(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e)};exports.default=e;
